import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { trigger, transition, style, animate } from "@angular/animations";
import { Employees } from "../../off-roll-leave-lop-management.component";
import { OffrollLopManagementService } from "src/app/core/services/offroll-lop-management.service";

@Component({
  selector: "app-side-popup",
  templateUrl: "./side-popup.component.html",
  styleUrls: ["./side-popup.component.css"],
  animations: [
    trigger("fadeInOut", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("800ms ease-in", style({ opacity: 1 })),
      ]),
      transition(":leave", [animate("0ms ease-out", style({ opacity: 0 }))]),
    ]),
    // animation for content refresh (when new row clicked)
    trigger("fadeContent", [
      transition("* => *", [
        style({ opacity: 0 }),
        animate("300ms ease-in", style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class SidePopupComponent implements OnInit {
  isLopInvalid: boolean;
  constructor
    (
      private offrollService: OffrollLopManagementService,
      private cd?: ChangeDetectorRef,
    ) { }

  @Input() selectedEmployee: any;
  @Input() fixedReimburses: any;
  @Input() projectCodes: any[] = [];
  @Input() selectedEmployees: any[] = [];
  @Input() totalemployees: any[] = [];
  @Input() getTotalLeavesFn!: (emp: Employees) => number;
  @Input() getIsFilterFn!: boolean;
  @Input() isHrAndManager: boolean;
  @Input() visible = false;
  @Input() mode: "single" | "bulk" = "single";
  @Input() isFormDisabled: boolean;
  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<any>();
  projectCode: string = null;
  unlistedProject: string = null;
  remarks: string = null;
  totalWorkingDays: number;
  projectCodeList: any[];
  isOtherSelected: boolean;
  readonly OTHER_OPTION = {
    id: 'other',
    type: "other",
    displayName: "➕ Other",
  };

  ngOnInit() {
    if (this.mode === "single" && this.selectedEmployee) {
      this.initializePayAdjustment();
    }

    this.refreshProjectList();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes["projectCodes"]) {
      this.refreshProjectList();

    }
    if (
      changes["selectedEmployee"] &&
      this.selectedEmployee &&
      this.mode === "single"
    ) {
      // Deep clone to avoid shared reference
      this.selectedEmployee = JSON.parse(JSON.stringify(this.selectedEmployee));
      //set totalworkingdays
      this.totalWorkingDays = this.selectedEmployee?.working_days;
      this.initializePayAdjustment();
    }

    // code to manage unlisted project  in bulk mode 
    if (this.mode === "bulk") {

      if (this.projectCode === "other") {
        this.isOtherSelected = true;
        return;
      }

      const unlisted = this.unlistedProject;
      const hasValidUnlisted =
        typeof unlisted === "string" &&
        unlisted.trim() !== "" &&
        unlisted.trim().toLowerCase() !== "null" &&
        unlisted.trim().toLowerCase() !== "undefined";

      if (this.projectCode === null && this.unlistedProject && hasValidUnlisted) {
        this.isOtherSelected = true;
        this.projectCode = "other";
      } else {
        this.isOtherSelected = false;
      }

    }

  }

  // to add custom option need to modified project list 
  private refreshProjectList() {
    this.projectCodeList = [
      this.OTHER_OPTION,
      ...(this.projectCodes || []),
    ];
  }



  customSearchFn(term: string, item: any) {
    return true; // always show items EXACTLY as they are in projectCodeList
  }

  // function execute when search perform in project dropdown
  onProjectSearch(term: string) {
    const search = (term || "").toLowerCase();

    if (!search) {
      this.refreshProjectList();
      return;
    }

    const filtered = (this.projectCodes || []).filter(item =>
      item.displayName.toLowerCase().includes(search)
    );

    this.projectCodeList = [
      this.OTHER_OPTION,
      ...filtered
    ];
  }

  // function execute when project dropdown will change 

  onProjectChange(selectedObj: any) {
    const isBulk = this.mode === "bulk";
    // User cleared the dropdown
    if (!selectedObj) {
      this.isOtherSelected = false;
      if (isBulk) {
        this.projectCode = null;
        this.unlistedProject = null;
      } else {
        this.selectedEmployee.pay_adjustment.project = null;
        this.selectedEmployee.pay_adjustment.unlisted_project = null;
      }
      //Reset full project list (Otherwise dropdown still shows ONLY Other)
      this.refreshProjectList();
      return;
    }

    // User selected "Other"
    if (selectedObj.id === "other" || selectedObj.type === "other") {
      this.isOtherSelected = true;
      if (isBulk) {
        this.projectCode = "other";
        //this.refreshProjectList();
      } else {
        console.log("inside single  ");
        this.selectedEmployee.pay_adjustment.project = "other";

      }
      return;
    }

    // User selected a normal project
    this.isOtherSelected = false;

    if (isBulk) {
      this.projectCode = selectedObj.id;
      this.unlistedProject = null;
    } else {
      this.selectedEmployee.pay_adjustment.project = selectedObj.id;
      this.selectedEmployee.pay_adjustment.unlisted_project = null;
    }

  }


  onProjectClear() {
    this.isOtherSelected = false;
    this.projectCode = null;
    this.refreshProjectList();
  }


  onClose() {
    this.close.emit();
  }

  onSubmit() {
    let payload: any;

    if (this.mode === "bulk") {
      payload = {
        emp_id: this.selectedEmployees.map((emp: any) => emp.emp_id) || [],
        project: this.projectCode === "other" ? null : this.projectCode,
        unlisted_project: this.unlistedProject || null,
        remarks: this.remarks?.trim() || null,
        type: "bulk",
      };
    }
    else if (this.mode === "single" && this.selectedEmployee?.pay_adjustment) {
      const adj = this.selectedEmployee.pay_adjustment;
      payload = {
        emp_id: this.selectedEmployee.emp_id || '',
        loss_of_pay_days: adj.loss_of_pay_days || 0,
        deduction: adj.deduction || 0,
        fixed_reimbursement: adj.fixed_reimbursement || null,
        payable_days: adj.payable_days || this.totalWorkingDays,
        project: (this.selectedEmployee.pay_adjustment.project === "other")
          ? null
          : this.selectedEmployee.pay_adjustment.project,
        unlisted_project: adj.unlisted_project || null,
        remarks: adj.remarks?.trim() || this.remarks?.trim() || null,
        type: "single",
        ...(adj.id && adj.id > 0 ? { id: adj.id } : {})
      };
    }

    // emit payload
    this.submit.emit(payload);
  }



  private initializePayAdjustment() {
    if (!this.selectedEmployee) return;
    const emp = this.selectedEmployee;

    if (!emp.pay_adjustment) {
      emp.pay_adjustment = {
        id: 0,
        date: "",
        loss_of_pay_days: 0,
        fixed_reimbursement: null,
        deduction: null,
        payable_days: this.totalWorkingDays,
        remarks: "",
        is_disabled: false,
        employee: emp.emp_id || "",
        project: null,
        unlisted_project: null
      };

    }

    const adj = emp.pay_adjustment;
    emp.pay_adjustment = {
      id: adj.id ?? 0,
      date: adj.date ?? "",
      loss_of_pay_days: Number(adj.loss_of_pay_days ?? 0),
      fixed_reimbursement: adj.fixed_reimbursement ?? null,
      deduction: adj.deduction ?? null,
      payable_days:
        adj.payable_days ??
        this.totalWorkingDays - Number(adj.loss_of_pay_days ?? 0),
      remarks: adj.remarks ?? "",
      is_disabled: adj.is_disabled ?? false,
      employee: adj.employee ?? emp.emp_id ?? "",
      project: adj.project ?? null,
      unlisted_project: adj.unlisted_project ?? null
    };

    //code  for filling unlisted project code if code came from backend 
    //validation constant
    const unlisted = adj.unlisted_project;
    const hasValidUnlisted =
      typeof unlisted === "string" &&
      unlisted.trim() !== "" &&
      unlisted.trim().toLowerCase() !== "null" &&
      unlisted.trim().toLowerCase() !== "undefined";

    if (this.mode === "single" &&
      emp.pay_adjustment.project === null &&
      emp.pay_adjustment.unlisted_project &&
      hasValidUnlisted
    ) {
      this.isOtherSelected = true;
      this.selectedEmployee.pay_adjustment.project = "other";
    } else {
      this.isOtherSelected = false;
    }

  }

  // on change lop input 
  onLopChange(value: any) {
    if (!this.selectedEmployee.pay_adjustment) return;
    // value can be '' (empty string) when user clears the input
    // treat empty as 0 ()
    if (value === "" || value === null || value === undefined) {
      this.selectedEmployee.pay_adjustment.loss_of_pay_days = 0;
      this.selectedEmployee.pay_adjustment.payable_days = this.totalWorkingDays;
    } else {
      let lop = Number(value);
      if (isNaN(lop)) lop = 0;

      if (lop > this.totalWorkingDays) {
        this.isLopInvalid = true;
      } else {
        this.isLopInvalid = false;
      }

      lop = Math.max(0, Math.min(this.totalWorkingDays, lop));
      this.selectedEmployee.pay_adjustment.loss_of_pay_days = lop;
      this.selectedEmployee.pay_adjustment.payable_days = Math.max(
        0,
        this.totalWorkingDays - lop
      );
    }

    if (this.cd) this.cd.detectChanges();

  }
}
